import { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import SelfRegistrationForm from "../../components/Forms/SelfRegistrationForm";
import LinkStatusCard from "../../components/LinkStatus/LinkStatusCard";
import axios from "../../services/api/api";

function StudentSelfRegistration() {
  // "checking" | "valid" | "expired" | "tooManyRequests" | "error"
  const [linkStatus, setLinkStatus] = useState("checking");
  const [role, setRole] = useState(null);

  const { search } = useLocation();
  const query = useMemo(() => new URLSearchParams(search), [search]);

  const token = query.get("check");

  // Rå, ej avkodad: en gammal länk (före #17921) bär en krypterad adress som bara går att läsa
  // ur strängen som den står i adressfältet. Används bara för att fylla i formuläret vid ogiltig länk.
  const legacyCheck = search.startsWith("?check=")
    ? search.slice("?check=".length)
    : null;

  // Handledaren landar här igen efter registreringen (sidan laddas om) och ska då se
  // APL-appens länkar, inte "Länken har gått ut" för den nu förbrukade länken.
  const aplSupervisorHasRegistered = localStorage.getItem(
    "aplSupervisorHasRegistered",
  );

  useEffect(() => {
    if (aplSupervisorHasRegistered) {
      return;
    }

    if (!token) {
      setLinkStatus("expired");
      return;
    }

    axios
      .post("/User/ValidateActivationToken", { token })
      .then((response) => {
        setRole(response.data.result.role);
        setLinkStatus("valid");
      })
      .catch((err) => {
        if (err.response?.status === 404) {
          setLinkStatus("expired");
        } else if (err.response?.status === 429) {
          setLinkStatus("tooManyRequests");
        } else {
          setLinkStatus("error");
        }
      });
  }, [token, aplSupervisorHasRegistered]);

  if (aplSupervisorHasRegistered || linkStatus === "valid") {
    return (
      <SelfRegistrationForm
        token={token}
        role={role}
        onLinkExpired={() => setLinkStatus("expired")}
      />
    );
  }

  if (linkStatus === "checking") {
    return null;
  }

  return (
    <LinkStatusCard
      linkStatus={linkStatus}
      requestNewLinkPath="/activation/resend"
      legacyCheck={legacyCheck}
    />
  );
}

export default StudentSelfRegistration;
